import './BranchStatistic.scss';

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useEffect } from "react";

import { fetchBranch } from "../../slices/statisticSlice";

import { Box } from "@mui/material";

import ReactECharts from "echarts-for-react";

const BranchStatistic = ({params}) => {
    const dispatch = useDispatch();
    const branchStatistic = useSelector((state) => state.statistic.branchStatistic);
    const token = useSelector((state) => state.auth.token?.data?.token || state.auth.token);

    useEffect(() => {
        dispatch(fetchBranch({token, params}));
    }, [dispatch, token, params]);

    console.log("params", params);
    console.log("typeof params", typeof params);

    const option = {
        title: {
            text: 'Количество аварий по филиалам',
            left: 'center'
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '15%',
            containLabel: true
        },
        xAxis: {
            type: 'category',
            data: branchStatistic.map(item => item.alias || item.name),
            axisLabel: {
                rotate: 40,
                fontSize: 10
            }
        },
        yAxis: {
            type: 'value'
        },
        series: [
            {
                type: 'bar',
                showBackground: true,
                backgroundStyle: {
                    color: 'rgba(180, 180, 180, 0.2)'
                },

                data: branchStatistic.map(item => item.count)
            }
        ]
    }

    return (
        <Box className={"branch_statistic"}>
            <ReactECharts option={option} style={{width: '100%', height: '100%'}}/>
        </Box>
    )
}

export default BranchStatistic;